<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.ADD') }} {{ $t('DEVICES.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div class="d-flex justify-space-between">
        <p class="text-body-1">
          <span class="text--secondary">
            {{ $t('DEVICES.DATE_OF_REGISTRATION') }}:
          </span>
          <span class="text--primary">
            {{ device.from | dateFormat }}
          </span>
        </p>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <device-form
          v-model="device"
          :type="$options.PERSON"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
        <confirm-dialog ref="confirm" />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { dateFormat, dateFormatBackend } from '@/modules/_global/filters';
import { DevicesService } from '@/services/devices.service';
import { onceRequest } from '@/modules/_global/utils/common';
import DeviceForm, {
  PERSON
} from '@/modules/devices/components/forms/DeviceForm.vue';
import checkDeviceCode from '@/modules/devices/mixins/checkDeviceCode';

export default {
  name: 'CreateDevice',

  PERSON,

  filters: {
    dateFormat
  },

  components: {
    DeviceForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  mixins: [errors, checkDeviceCode],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      device: {
        from: dateFormatBackend(new Date()),
        available_for_market: false
      }
    };
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),

    cancel() {
      this.$emit('cancel');
    },

    create: onceRequest(function create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const device = {
        person_id: this.personId,
        ...this.device
      };

      return this.checkWarhouseDeviceCode()
        .then(confirm => {
          return !confirm || this.showConfirm();
        })
        .then(confirm => {
          if (confirm) {
            return this.createDevice(device);
          }
        });
    }),

    createDevice(device) {
      return DevicesService.create(device)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });

          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
